export enum MailCodeOfferStatus {
  COMPLETE = 'COMPLETE',
  NO_MAIL_CODE = 'NO_MAIL_CODE',
  NO_OFFER = 'NO_OFFER',
  PARTIAL = 'PARTIAL',
}
